/**
 * Длительность видео по URL, измеренная самим браузером.
 *
 * Нужна цене: у тарифов, где вход оплачивается вместе с выходом, без длины
 * приложенного видео бар показывает сумму меньше той, что спишется. Сервер
 * измеряет её сам при создании задания, но до отправки файла у него нет —
 * котировке длину приносит тот, у кого файл уже есть, то есть браузер.
 *
 * Значение отдаётся СЫРЫМ, без округления: приводит его к секундам счёта
 * сервер — тем же правилом, что и probe, иначе показанная цена разошлась бы
 * со списанной на секунду.
 *
 * Не измерилось (битый файл, поток без известной длительности, отказ сети) —
 * `null`: цена тогда считается как прежде, без входа, а не падает.
 */
export function probeVideoDurationSeconds(url: string): Promise<number | null> {
    return new Promise((resolve) => {
        const video = document.createElement("video");
        // Метаданных достаточно — сам поток качать незачем.
        video.preload = "metadata";
        video.muted = true;

        const finish = (value: number | null) => {
            video.removeAttribute("src");
            video.load();
            resolve(value);
        };

        video.onloadedmetadata = () => {
            const { duration } = video;
            finish(Number.isFinite(duration) && duration > 0 ? duration : null);
        };
        video.onerror = () => finish(null);

        video.src = url;
    });
}
